import { Container } from 'metrix-common3';
import { useEffect } from 'react';
import ListFooter from './Footer';
import ListHeader from './Header';
import ListResults from './Results';

const List = (props) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: only re-run on listed deps
    useEffect(() => {
        props.doReduceView('list');

        if (props.query.list.search) {
            props.doQueryPolicies();
        } else {
            props.doGetListPolicies();
        }
    }, [props.query.list.search]);

    return (
        <Container>
            <ListHeader {...props} />
            <ListFooter {...props} />
            <ListResults {...props} />
            <ListFooter {...props} />
        </Container>
    );
};

export default List;
